export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const JOIN_GROUP = "JOIN_GROUP";
export const SIGNUP_DONE = "SIGNUP_DONE";

